// removed by extract-text-webpack-plugin
module.exports = {"defaultInput":"I6v1iU54","sectionWithHeader":"hkX9U6pl","content":"_2vx06MRj","plan":"M-9luzWg","separator":"_3lyV5Twm","titlePlan":"_1Ey14NPz","price":"_2dW9G9KS","duration":"_1lm0w3T0","description":"_3VlLcFXU","sectionPlan":"_1DVFjM_j","elrement":"X30gi-uw","plans-container":"ERC8UQHm","banned-background":"_1JMI_m-t","titles":"_2_PnBx8S","plan-description":"_3zXJg8IH","plan-container":"_3T5kdtDl","plan-card":"_1wKl_cUh","card-title":"_29Wd8mja","card-price":"_3NAFI7q6","smaller-title":"dn7SfrCK","choose-button":"_2p7B8qTt","details-container":"_2B7-gyo4","ul":"_2WSmFKBo"};


//////////////////
// WEBPACK FOOTER
// ./src/client/website/pages/ChallengePage/ChallengePage.styl
// module id = 339
// module chunks = 0